module.exports = __webpack_public_path__ + "/bundle/asset/U1_05-fae1a1b0e9d3fea20a2afe8fa9da4d01.gif";